export default __webpack_public_path__ + "static/media/ico-edit-black.127e987e.svg";